
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 26.666 640 426.666"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","stroke-width":"1pt"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h640v480H0z"}}),_c('path',{attrs:{"fill":"#00267f","d":"M0 0h213.3v480H0z"}}),_c('path',{attrs:{"fill":"#f31830","d":"M426.7 0H640v480H426.7z"}})])])
          )
        }
      }
    